// extracted by mini-css-extract-plugin
export default {"auth_header":"AuthHeader_auth_header__DBnTe","title":"AuthHeader_title__p3eXL","back":"AuthHeader_back__i-3UG","close":"AuthHeader_close__VGMQo"};